export default {
  title: 'My documents',
  description: 'Your uploaded business documents. You can download or replace them at any time.',
  document_types: {
    owner_document: 'Owner identity document',
    business_document: 'Business document',
  },
  kinds: {
    vat_registration: 'VAT registration',
    trade_registration: 'Trade registration',
    trade_license: 'Trade license',
    commercial_register_extract: 'Commercial register extract',
    financial_statements: 'Financial statements',
    bank_statement: 'Bank statement',
    shareholder_list: 'List of shareholders',
    other: 'Other',
    passport: 'Passport',
    driver_license: "Driver's license",
    id_card: 'ID card',
    residence_permit: 'Residence permit',
  },
  sides: {
    front: 'Front',
    back: 'Back',
  },
  fields: {
    slot: 'Category',
    document: 'Document',
    kind: 'Kind',
    side: 'Side',
    uploaded_at: 'Uploaded',
    expires_at: 'Expires',
    retained_until: 'Retained until',
    deleted_at: 'Deleted',
    storage_deleted_at: 'Permanently deleted',
    actions: 'Actions',
  },
  values: {
    no_slot: 'Other',
    no_file_name: '—',
    version: 'v{{version}}',
  },
  filters: {
    type_placeholder: 'Filter by document type',
    kind_placeholder: 'Filter by kind',
  },
  retention: {
    deletable: 'Deletable',
    tooltip:
      'German law (GoBD / §147 AO) requires us to retain this document until {{date}}. It can only be deleted after that date.',
    tooltip_no_date: 'This document is subject to a statutory retention period and cannot be deleted yet.',
  },
  buttons: {
    upload: 'Upload',
    upload_other: 'Other document',
    retry_slots: "Couldn't load the documents — try again",
    download: 'Download',
    download_front: 'Download front',
    download_back: 'Download back',
    reupload: 'Re-upload',
    delete: 'Delete',
  },
  empty: 'You have not uploaded any documents yet.',
  delete_modal: {
    title: 'Delete document',
    description:
      'Choose how to delete this document. "Delete" archives it and hides it from your list. "Permanently delete" erases the files for good and is only possible once the statutory retention period has ended.',
    delete: 'Delete',
    permanently_delete: 'Permanently delete',
    cancel: 'Cancel',
    retention_alert:
      'These documents are subject to statutory retention periods under German law (GoBD / §147 AO). Permanently deleting a document removes its files irreversibly.',
  },
  reupload_modal: {
    title: 'Re-upload document',
    description: 'Upload a new version of this document. The previous version will be replaced.',
    type: {
      label: 'Document type',
      placeholder: 'Select document type',
    },
    kind: {
      label: 'Document kind',
      placeholder: 'Select document kind',
    },
    front: {
      label: 'Document front',
    },
    back: {
      label: 'Document back (optional for some documents)',
    },
    expires_at: {
      label: 'Document expiry date',
      placeholder: 'Select expiry date',
    },
    buttons: {
      select_file: 'Select file',
      submit: 'Upload',
      cancel: 'Cancel',
    },
  },
  toasts: {
    download_error: 'Failed to download the document.',
    delete_success: 'Document deleted successfully.',
    delete_error: 'Failed to delete the document.',
    reupload_success: 'Document uploaded successfully.',
    reupload_error: 'Failed to upload the document.',
  },
};
